import { ref } from "vue";

const useToggle = (defaultValue) => {
  const state = ref(defaultValue);

  const toggle = (value = !state.value) => {
    state.value = value;
  };

  return [state, toggle];
};

export default useToggle;
